<div class="subheading-container">
  <capra-icon icon="icon-calendar"></capra-icon>
  <h3 class="subheading">Cadence</h3>
</div>
<mode-cadence-selector
  name="cadence"
  [cadence]="schedule.frequency"
  (cadenceChange)="frequencyChange.emit($event)"
></mode-cadence-selector>
<ng-container [ngSwitch]="schedule.frequency">
  <mode-minute-schedule-config
    *ngSwitchCase="'every_15_minutes'"
    [frequencyType]="schedule.frequency"
    [startTimeSelected]="schedule.minute"
    (startTimeChanged)="startTimeChanged.emit($event)"
  ></mode-minute-schedule-config>
  <mode-minute-schedule-config
    *ngSwitchCase="'every_30_minutes'"
    [frequencyType]="schedule.frequency"
    [startTimeSelected]="schedule.minute"
    (startTimeChanged)="startTimeChanged.emit($event)"
  ></mode-minute-schedule-config>
  <mode-minute-schedule-config
    *ngSwitchCase="'hourly'"
    [frequencyType]="schedule.frequency"
    [startTimeSelected]="schedule.minute"
    (startTimeChanged)="startTimeChanged.emit($event)"
  ></mode-minute-schedule-config>
  <mode-time-with-time-zone-selector
    *ngSwitchCase="'daily'"
    [schedule]="schedule"
    (timeChanged)="timeChanged.emit($event)"
  ></mode-time-with-time-zone-selector>
  <mode-time-with-time-zone-selector
    *ngSwitchCase="'weekday'"
    [schedule]="schedule"
    (timeChanged)="timeChanged.emit($event)"
  ></mode-time-with-time-zone-selector>
  <mode-weekly-schedule-config
    *ngSwitchCase="'weekly'"
    [schedule]="schedule"
    (dayOfWeekChanged)="dayOfWeekChanged.emit($event)"
    (timeChanged)="timeChanged.emit($event)"
  ></mode-weekly-schedule-config>
  <mode-monthly-schedule-config
    *ngSwitchCase="'monthly'"
    [schedule]="schedule"
    (dayOfMonthChanged)="dayOfMonthChanged.emit($event)"
    (timeChanged)="timeChanged.emit($event)"
  >
  </mode-monthly-schedule-config>
</ng-container>
